import React, { Key, useState } from "react";
import { Col, message, Modal, Row, Select } from "antd";
import { ModalProps } from "antd/es/modal";
import { useMount } from "react-use";
import useRequestFn from "../../../../../../../utils/useRequestFn";
import {
    getMachineRoomIpList,
    saveIpRange
} from "../../../../../../../service/exam";
import { errorMessage } from "../../../../../../../service/service";

interface MachineRoomModalProps extends ModalProps {
    selected: Key[];
    onOk?(): void;
}

export function MachineRoomModal({
    onOk,
    selected,
    ...props
}: MachineRoomModalProps) {
    const [machineRoomId, setMachineRoomId] = useState<string | undefined>(
        undefined
    );

    const [onSearch, { loading, data: optionData }] = useRequestFn(
        async (search?: string) => {
            return getMachineRoomIpList(search);
        }
    );

    const [onSave, saveStatus] = useRequestFn(async () => {
        try {
            await saveIpRange(selected, machineRoomId!);
            onOk?.();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    useMount(onSearch);

    return (
        <Modal
            title="机房设定"
            okButtonProps={{
                disabled: !machineRoomId,
                loading: saveStatus.loading
            }}
            onOk={onSave}
            {...props}>
            <Row>
                <Col span={6} style={{ textAlign: "right" }}>
                    机房:
                </Col>

                <Col span={12} offset={1}>
                    <Select
                        style={{ width: "100%" }}
                        placeholder="请选择"
                        showSearch
                        onSearch={onSearch}
                        filterOption={false}
                        allowClear
                        loading={loading}
                        value={machineRoomId}
                        onChange={setMachineRoomId}>
                        {optionData?.map(item => (
                            <Select.Option value={item.id} key={item.id}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Col>
            </Row>
        </Modal>
    );
}
